module.exports = __webpack_public_path__ + "assets/img/roberto.835dbd92.jpg";